import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";

// Components
import App from "./App";

//
import store from "./store/index";
import "./styles/loading-state.scss";
import "./styles/main.scss";
import i18nextConfig from "./config/i18next";

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
